$(document).ready(function() {
    //This is read by BaseUser controller and set in CurrentUser
    document.cookie='delta-tz-mins=' + new Date().getTimezoneOffset();
});